module.exports = __webpack_public_path__ + "img/MJSS_WCZ.438e0c12.png";